import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../../services/search-analytics-service";

export const fetchAggregatedSearches = createAsyncThunk(
  "searchAnalytics/fetchAggregatedSearches",
  async (params = {}, { rejectWithValue }) => {
    try {
      return await api.getAggregatedSearches(params);
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

export const fetchSearchEvents = createAsyncThunk(
  "searchAnalytics/fetchSearchEvents",
  async (params = {}, { rejectWithValue }) => {
    try {
      return await api.getSearchEvents(params);
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

export const exportSearchAnalytics = createAsyncThunk(
  "searchAnalytics/exportSearchAnalytics",
  async (params = {}, { rejectWithValue }) => {
    try {
      return await api.exportSearchEvents(params);
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);
